import { createReducer } from 'redux-act';

import {
  WEB_LAYOUT_FETCH,
  WEB_LAYOUT_FETCH_DATA_SUCCESS,
  WEB_LAYOUT_FETCH_DATA_FAIL,
  WEB_LAYOUT_DELETE_INIT,
  WEB_LAYOUT_DELETE_SUCCESS,
  WEB_LAYOUT_DELETE_FAIL,
  WEB_LAYOUT_CLEAR_DATA,
  WEB_LAYOUT_CREATE_INIT,
  WEB_LAYOUT_CREATE_SUCCESS,
  WEB_LAYOUT_CREATE_FAIL,
  WEB_LAYOUT_MODIFY_INIT,
  WEB_LAYOUT_MODIFY_SUCCESS,
  WEB_LAYOUT_MODIFY_FAIL,
  WEB_LAYOUT_CLEAN_UP,
  WEB_LAYOUT_CLEAR_DATA_LOGOUT,
} from 'state/actions/webLayout';

const initialState = {
  list: [],
  loading: false,
  error: null,
  success: false,
  deleted: false,
  updated: false,
};

export const webLayoutReducer = createReducer(
  {
    [WEB_LAYOUT_FETCH]: () => ({
      ...initialState,
      loading: true,
    }),
    [WEB_LAYOUT_FETCH_DATA_SUCCESS]: (state, payload) => {
      console.log('payload web layout', payload);
      return {
        ...state,
        list: payload.WEB_LAYOUT.data || [],
        loading: false,
        error: null,
      };
    },
    [WEB_LAYOUT_FETCH_DATA_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_LAYOUT_DELETE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_LAYOUT_DELETE_SUCCESS]: (state, payload) => ({
      ...state,
      loading: false,
      error: null,
      deleted: true,
    }),
    [WEB_LAYOUT_DELETE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_LAYOUT_CLEAR_DATA]: (state) => ({
      ...initialState,
      list: state.list,
    }),
    [WEB_LAYOUT_CREATE_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_LAYOUT_CREATE_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.WEB_LAYOUT.data || [],
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_LAYOUT_CREATE_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_LAYOUT_MODIFY_INIT]: (state) => ({
      ...state,
      loading: true,
    }),
    [WEB_LAYOUT_MODIFY_SUCCESS]: (state, payload) => ({
      ...state,
      list: payload.WEB_LAYOUT.data || [],
      loading: false,
      error: null,
      success: true,
      updated: true,
    }),
    [WEB_LAYOUT_MODIFY_FAIL]: (state, payload) => ({
      ...state,
      loading: false,
      error: payload.error,
    }),
    [WEB_LAYOUT_CLEAN_UP]: (state) => ({
      ...state,
      loading: false,
      error: null,
      success: false,
      deleted: false,
      updated: false,
    }),
    [WEB_LAYOUT_CLEAR_DATA_LOGOUT]: () => ({
      ...initialState,
    }),
  },
  initialState
);
